import { render, staticRenderFns } from "./aishipin.vue?vue&type=template&id=34b3a277&scoped=true"
import script from "./aishipin.vue?vue&type=script&lang=js"
export * from "./aishipin.vue?vue&type=script&lang=js"
import style0 from "./aishipin.vue?vue&type=style&index=0&id=34b3a277&prod&scoped=true&lang=css"
import style1 from "./aishipin.vue?vue&type=style&index=1&id=34b3a277&prod&lang=css"
import style2 from "./aishipin.vue?vue&type=style&index=2&id=34b3a277&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "34b3a277",
  null
  
)

export default component.exports